/* Suppress pointer right-clicks while keeping native editing and keyboard menus. */
document.addEventListener('contextmenu', (event) => {
  const editable = event.composedPath().some((node) =>
    node instanceof HTMLElement && (node.matches('input, textarea, select') || node.isContentEditable)
  );
  if (editable) return;

  if (event.button === 2 || (event.button === 0 && event.ctrlKey)) {
    event.preventDefault();
  }
});
